var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { debounce } from 'lodash';
import { useCallback, useEffect, useRef, useState } from 'react';
function applyFunc(func) {
    func();
}
export function useApiFetch(getFunc, init, errReturn, abortController, tDebounce, delayLoading) {
    const idFunc = useCallback((x) => x, []);
    return useApiFetchWithFilter(getFunc, init, errReturn, abortController, idFunc, tDebounce, delayLoading);
}
export function useApiFetchWithFilter(getFunc, init, errReturn, abortController, filter, tDebounce, delayLoading) {
    const [data, setData] = useState(init);
    const [loading, setLoading] = useState(false);
    const [reload, setReload] = useState(false);
    const loadingFlag = useRef(false);
    const triggerReload = () => setReload(x => !x);
    const getData = useCallback(() => __awaiter(this, void 0, void 0, function* () {
        try {
            const res = yield getFunc();
            setData(filter(res));
        }
        catch (error) {
            if (abortController.signal.aborted) {
                return;
            }
            else {
                setData(errReturn);
            }
        }
        finally {
            if (!abortController.signal.aborted) {
                loadingFlag.current = false;
                setLoading(false);
            }
        }
    }), [getFunc, filter, errReturn, abortController]);
    const debounceApplyFunc = useCallback(debounce(applyFunc, tDebounce), [tDebounce]);
    useEffect(() => {
        loadingFlag.current = true;
        if (delayLoading) {
            setTimeout(() => {
                if (!abortController.signal.aborted) {
                    if (loadingFlag.current === true) {
                        setLoading(true);
                    }
                }
            }, delayLoading);
        }
        else {
            setLoading(true);
        }
        debounceApplyFunc(getData);
    }, [getData, debounceApplyFunc, reload, delayLoading, abortController]);
    return [data, loading, triggerReload];
}
